const loadingLabel = "Chargement";
const frCH = {
  loadingLabel
};
export {
  frCH as default,
  loadingLabel
};
